import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-charging',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './charging.component.html',
  styleUrls: ['./charging.component.scss']
})
export class ChargingComponent {
  @Input() isLoading: boolean = false;
  @Input() message?: string;

  showSpinner(message?: string): void {
    this.isLoading = true;
    if (message) this.message = message;
  }

  hideSpinner(): void {
    this.isLoading = false;
    this.message = undefined;
  }
}